import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRideEvent = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 38,
	viewBox: "0 0 38 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_live_map_ride_event)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					width: 34,
					height: 34,
					rx: 17,
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 1,
					y: 1,
					width: 32,
					height: 32,
					rx: 16,
					stroke: "white",
					strokeWidth: 2
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.406 18.1111H8.13533H21.7593H10.406ZM10.1449 24.7778V27H8.74614V24.3378C8.29428 24.1622 7.8901 23.7956 7.53361 23.2378C7.17787 22.6815 7 22.127 7 21.5744V11.4444C7 10.2519 7.7005 9.39815 9.1015 8.88333C10.5025 8.36852 12.8243 8.11111 16.0668 8.11111C15.9668 8.28815 15.8741 8.46556 15.7886 8.64333C15.7031 8.82111 15.6308 9.01185 15.5718 9.21556C13.1611 9.25259 11.3907 9.40667 10.2607 9.67778C9.13064 9.94815 8.46155 10.3663 8.25341 10.9322H15.2289C15.216 11.1174 15.2096 11.3026 15.2096 11.4878C15.2096 11.673 15.2232 11.8581 15.2505 12.0433H8.13533V17H18.1421C18.4343 17.2311 18.7465 17.4404 19.0788 17.6278C19.4111 17.8152 19.7645 17.9763 20.1392 18.1111H8.13533V21.4444C8.13533 22.0556 8.35786 22.5789 8.80291 23.0144C9.24796 23.45 9.78232 23.6674 10.406 23.6667H19.4886C20.1131 23.6667 20.6478 23.4493 21.0929 23.0144C21.5379 22.5796 21.7601 22.0563 21.7593 21.4444V18.4978C21.9485 18.5244 22.1378 18.5378 22.327 18.5378C22.5162 18.5378 22.7054 18.5315 22.8946 18.5189V21.5722C22.8946 22.1248 22.7164 22.6804 22.3599 23.2389C22.0034 23.7959 21.5992 24.1622 21.1474 24.3378V27H19.7509V24.7778H10.1449ZM22.4587 15.8889C21.1932 15.8889 20.1199 15.4578 19.2389 14.5956C18.3579 13.7319 17.9173 12.6815 17.9173 11.4444C17.9173 10.2104 18.3567 9.16111 19.2355 8.29667C20.1142 7.43222 21.1886 7 22.4587 7C23.7227 7 24.7956 7.43148 25.6773 8.29444C26.5591 9.15667 27 10.2067 27 11.4444C27 12.6822 26.555 13.7326 25.6649 14.5956C24.7748 15.4585 23.706 15.8896 22.4587 15.8889ZM22.0216 12.1289H22.8946V8.79556H22.0204L22.0216 12.1289ZM22.4575 14.18C22.6089 14.18 22.7308 14.1315 22.8231 14.0344C22.9139 13.9374 22.9669 13.8219 22.9821 13.6878C22.9821 13.5396 22.9329 13.4137 22.8345 13.31C22.7353 13.2063 22.6101 13.1544 22.4587 13.1544C22.3073 13.1544 22.182 13.2026 22.0829 13.2989C21.9837 13.3952 21.9341 13.5178 21.9341 13.6667C21.9341 13.8156 21.9833 13.9378 22.0817 14.0333C22.1817 14.1311 22.3062 14.18 22.4575 14.18ZM11.874 21.77C12.1185 21.5315 12.2407 21.2378 12.2407 20.8889C12.2407 20.54 12.1185 20.2463 11.874 20.0078C11.6303 19.7685 11.3302 19.6489 10.9737 19.6489C10.6172 19.6489 10.3171 19.7685 10.0733 20.0078C9.82887 20.2463 9.70663 20.54 9.70663 20.8889C9.70663 21.2378 9.82887 21.5315 10.0733 21.77C10.3171 22.0093 10.6172 22.1289 10.9737 22.1289C11.3302 22.1289 11.6303 22.0093 11.874 21.77ZM19.8213 21.77C20.0658 21.5315 20.188 21.2378 20.188 20.8889C20.188 20.54 20.0658 20.2463 19.8213 20.0078C19.5776 19.7685 19.2775 19.6489 18.921 19.6489C18.5645 19.6489 18.2644 19.7685 18.0207 20.0078C17.7762 20.2463 17.654 20.54 17.654 20.8889C17.654 21.2378 17.7762 21.5315 18.0207 21.77C18.2644 22.0093 18.5645 22.1289 18.921 22.1289C19.2775 22.1289 19.5776 22.0093 19.8213 21.77Z",
					fill: "white"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_live_map_ride_event",
			x: 0,
			y: 0,
			width: 37.4,
			height: 37.4,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: 2,
					dy: 2
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .7 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_live_map_ride_event"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_live_map_ride_event",
					result: "shape"
				})
			]
		}) })
	]
});
const ForwardRef = forwardRef(SvgRideEvent);
export { ForwardRef as ReactComponent };
